import { inject, Injectable } from "@angular/core";
import { BehaviorSubject, Observable, map, tap } from "rxjs";
import { CompanyDetails } from "src/app/shared/interfaces/company.interface";
import { ValidationError } from "src/app/shared/interfaces/validation-error.interface";
import { EMPLOYEE_SERVICE_API } from "../apis/employee-service";
import { ApiService } from "./api.service";

@Injectable({
  providedIn: "root",
})
export class ObservableService {
  // #region List of Enterprises

  private companies = new BehaviorSubject<CompanyDetails[]>([]);
  private readonly API = inject(ApiService);

  setCompanyList(data: CompanyDetails[]) {
    this.companies.next(data);
  }

  getCompanyList(): Observable<CompanyDetails[]> {
    return this.companies.asObservable();
  }

  // #endregion

  // #region Form Validation Errors

  private validation_errors = new BehaviorSubject<ValidationError>({});

  setValidationErrors(errors: ValidationError) {
    this.validation_errors.next(errors);
  }

  getValidationErrors() {
    return this.validation_errors.asObservable();
  }

  getListOfRequestStatus() {
    return this.API.getDataFromServer(EMPLOYEE_SERVICE_API.REQUEST_STATUS_LIST).pipe(
      map(status => Object.entries(status).map(([key, value]) => ({ id: key, name: value }))),
    );
  }

  // #endregion
}
